import React from 'react';
import { CollectionColumnTitle } from './collection-column-title';
import { Property } from './property';
import { useNotionContext } from '../context';
import { UseRetrieveBlocks } from '../hooks/useRetrieveBlocks';
export var CollectionRow = function (_a) {
    var _b, _c, _d, _e, _f;
    var block = _a.block;
    var _g = useNotionContext(), recordMap = _g.recordMap, hidePageProperty = _g.hidePageProperty;
    var retrieveMissingBlocks = UseRetrieveBlocks().retrieveMissingBlocks;
    if (hidePageProperty)
        return null;
    var collectionId = block.parent_id;
    var collection = (_b = recordMap.collection[collectionId]) === null || _b === void 0 ? void 0 : _b.value;
    var schemas = collection === null || collection === void 0 ? void 0 : collection.schema;
    if (!collection || !schemas) {
        return null;
    }
    var propertyIds = Object.keys(schemas).filter(function (id) { return id !== 'title'; });
    var missingBlocks = [];
    //look for the missing blocks.
    for (var _i = 0, propertyIds_1 = propertyIds; _i < propertyIds_1.length; _i++) {
        var prop = propertyIds_1[_i];
        for (var _h = 0, _j = ((_c = block === null || block === void 0 ? void 0 : block.properties) === null || _c === void 0 ? void 0 : _c[prop]) || []; _h < _j.length; _h++) {
            var decorator = _j[_h];
            if (!decorator || (decorator === null || decorator === void 0 ? void 0 : decorator.length) != 2)
                continue;
            var blockId = (_d = decorator === null || decorator === void 0 ? void 0 : decorator.flat()) === null || _d === void 0 ? void 0 : _d.flat()[2];
            if (typeof blockId !== 'string' ||
                (typeof blockId == 'string' &&
                    blockId.length != 36 &&
                    blockId.split('-').length != 5))
                continue;
            if (blockId.indexOf('http') != -1)
                continue;
            var type = schemas[prop].type;
            var table = '';
            switch (type) {
                case 'person':
                    table = 'notion_user';
                    break;
                default:
                    table = 'block';
            }
            !recordMap[table][blockId] && missingBlocks.push({ id: blockId, table: table });
        }
    }
    retrieveMissingBlocks(missingBlocks);
    // filter properties based on visibility
    if ((_e = collection.format) === null || _e === void 0 ? void 0 : _e.property_visibility) {
        propertyIds = propertyIds.filter(function (id) {
            var _a;
            return ((_a = collection.format.property_visibility.find(function (_a) {
                var property = _a.property;
                return property === id;
            })) === null || _a === void 0 ? void 0 : _a.visibility) !== 'hide';
        });
    }
    // sort properties
    if ((_f = collection.format) === null || _f === void 0 ? void 0 : _f.collection_page_properties) {
        // sort properties based on collection page order
        // const idToIndex = collection.format?.collection_page_properties.reduce(
        //   (acc, p, i) => ({
        //     ...acc,
        //     [p.property]: i
        //   }),
        //   {}
        // )
        // propertyIds.sort((a, b) => idToIndex[a] - idToIndex[b])
    }
    else {
        // default to sorting properties alphabetically based on name
        propertyIds.sort(function (a, b) { return schemas[a].name.localeCompare(schemas[b].name); });
    }
    propertyIds.sort(function (a, b) { return schemas[a].name.localeCompare(schemas[b].name); });
    return (React.createElement("div", { className: 'notion-collection-row' },
        React.createElement("div", { className: 'notion-collection-row-body' }, propertyIds.map(function (id) {
            var _a, _b, _c, _d;
            var schema = schemas[id];
            if ((_a = collection === null || collection === void 0 ? void 0 : collection.format) === null || _a === void 0 ? void 0 : _a.property_visibility) {
                var visibility = (_b = collection.format.property_visibility.find(function (_a) {
                    var property = _a.property;
                    return property === id;
                })) === null || _b === void 0 ? void 0 : _b.visibility;
                /*
                  if the visibility is set to hide_when_empty, then don't show it if the content is undefined.
                */
                if ((visibility === null || visibility === void 0 ? void 0 : visibility.startsWith('hide')) && !((_c = block.properties) === null || _c === void 0 ? void 0 : _c[id]))
                    return null;
            }
            return (React.createElement("div", { className: 'notion-collection-row-property', key: id },
                React.createElement(CollectionColumnTitle, { schema: schema }),
                React.createElement("div", { className: 'notion-collection-row-value' },
                    React.createElement(Property, { schema: schema, data: (_d = block.properties) === null || _d === void 0 ? void 0 : _d[id], block: block, collection: collection }))));
        }))));
};
//# sourceMappingURL=collection-row.js.map